"use client";

import { Box } from "@mui/material";

/**
 * Container for page sections with consistent max-width and padding
 */
export default function SectionContainer({
  children,
  backgroundColor = "background.default",
  maxWidth = "1200px",
  py = { xs: 6, md: 10 },
  ...props
}) {
  return (
    <Box
      component="section"
      sx={{
        backgroundColor,
        width: "100%",
        py,
        px: { xs: 4, sm: 4, md: 6 },
      }}
      {...props}
    >
      <Box
        sx={{
          maxWidth,
          mx: "auto",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
